import './Notes.css';
import startup_kinito from './assets/sounds/Startupa2c.ogg'

function Notes({rick = false}) {
  if (rick) {
    return <div id="Notes">
      <div className='noteDrag' windowdrag='true'/>
      <div className='horiDrag' windowdrag='true'/>
      <span style={{fontSize: '4vmin'}}>
        gottem<br/>
      </span>
        ok but seriously i have an actuaal website just remove the "learnmore" from the url pls check it out :3c
    </div>
  }
  return (
    <div id="Notes">
      <div className='noteDrag' windowdrag='true'/>
      <div className='horiDrag' windowdrag='true'/>
      <br/>
      <hr/>
      <br/>
      {'                    '}Pssst! Hey! Over here! :3c
      <div className='subbing'>{'                    '}if you're on mobile and it's unreadable, try landscape...?
      <br/>{'              '}but tbh mobile support would be annoying to implement now...</div>
      {/* <br/> */}
      <hr/>
      <br/>
      Thank you so much for checking out our little website!
      There's a few goofy little things here and there that you might want to know about.
      <br/><br/>
      <hr/>
      <br/>
      You can drag and fling these silly goober windows around with the title and side bar!
      Additionally, holding [SHIFT] lets you grab windows from anywhere!
      {/* <br/><br/>
      <hr/>
      <br/>
      The main profile window has several tabs, which you can click to view our individiual pages!
      <br/><br/>
      We're a median system, with me (Flare) and my buddy (Navy) as the primary peeps behind ourselves :3c */}
      <br/><br/>
      <hr/>
      <br/>
      You can stop and resume time by pressing [Z]!<br/>
      This stops all moving windows, and lets you fling other windows all at once :3c
      <br/><br/>
      You can also stop deceleration with [X]!<br/>
      This makes all moving windows never slow down, like DVD screensavers ^w^
      <br/><br/>
      <hr/>
      <br/>
      Over time, more stuff may be added!<br/>
      Thank you so much for checking out our website ^w^ Until next time!
      <br/><br/>
      <hr/>
      <br/>
      <div className='nosans'>
      {`     /￣ヽ                       ・*。
  ∠)_・/∧_∧ 　　              ・゜
       / / ( ･ω･) 　　            °。+*°。
    (　￣∪∪￣)                 .・゜          
  ~~~~~~~~~~~~`}
      <br/>
      <div className='subber'>from <a href='https://emojicombos.com/cat/'>https://emojicombos.com/cat/</a></div>
      </div>
      <div style={{
        textAlign: 'right'
      }}>
        <div className='subber'><a href='https://github.com/RealPacket/GG-Sans-font-files'>gg sans font</a> from <a href='https://discord.com/'>Discord</a></div>
        <div className='subber'><a href={startup_kinito}>startup sfx</a> from <a href='https://store.steampowered.com/app/2075070/KinitoPET/'>KinitoPET</a></div>
      </div>
    </div>
  );
}

export default Notes;